import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './auth-context';
import { checkPassCodeurStatus } from './stripe-service';

// Création du contexte
const PassCodeurContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const usePassCodeur = () => {
  const context = useContext(PassCodeurContext);
  if (!context) {
    throw new Error('usePassCodeur doit être utilisé à l\'intérieur d\'un PassCodeurProvider');
  }
  return context;
};

// Fournisseur du contexte
export const PassCodeurProvider = ({ children }) => {
  const { currentUser } = useAuth();
  // Pass Codeur activé pour tout le monde (visiteurs et inscrits)
  const [hasPassCodeur, setHasPassCodeur] = useState(true);
  const [purchasedAt, setPurchasedAt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  // Fonction pour charger le statut du Pass Codeur
  const loadPassCodeurStatus = useCallback(async () => {
    // Nouvelle règle : Pass Codeur offert à tout le monde
    setHasPassCodeur(true);
    setPurchasedAt(null);
    setLoadError(null);
    setIsLoading(false);
  }, [currentUser]);

  // Fonction pour mettre à jour le statut après un achat
  const updatePassCodeurStatus = useCallback((newStatus) => {
    setHasPassCodeur(newStatus.hasPassCodeur);
    setPurchasedAt(newStatus.purchasedAt);
  }, []);

  // Charger le statut à l'initialisation et quand l'utilisateur change
  useEffect(() => {
    loadPassCodeurStatus();
  }, [currentUser, loadPassCodeurStatus]);

  // Fonction pour vérifier si l'utilisateur a accès aux cours
  const hasAccessToCourses = useCallback(() => {
    // Toujours vrai : tous les visiteurs ont accès
    return true;
  }, []);

  // Valeurs du contexte
  const value = {
    hasPassCodeur,
    purchasedAt,
    isLoading,
    loadError,
    loadPassCodeurStatus,
    updatePassCodeurStatus,
    hasAccessToCourses
  };

  return (
    <PassCodeurContext.Provider value={value}>
      {children}
    </PassCodeurContext.Provider>
  );
}; 